import {useUser} from "../contexts/UserProvider";

export default function ProtectedContent({
                                           children,
                                           allowedRoles,
                                           allowedActions,
                                           alt
                                         }) {
  const {actions, roles} = useUser();
  let showContent = false;
  if (allowedRoles) {
    showContent = allowedRoles.some((role) => {
      return roles && roles.includes(role);
    });
  }
  if (!showContent && allowedActions) {
    showContent = allowedActions.some((action) => {
      return actions && actions.includes(action);
    })
  }
  return showContent ? <>{children}</> : <>{alt}</>;
}
